import localStorage from "../../helper/localStorage";

/**
 * 数据列表
 */
export default (obj) => {
    return {
        state: {
            requestUrl: obj.requestUrl,
            requestMethod: obj.requestMethod,
            loading: obj.loading,
            pageindex: obj.pageindex,
            pagesize: obj.pagesize,
            pagecount: obj.pagecount,
            totalcount: obj.totalcount,
            filterParams: obj.filterParams,
            dataList: obj.dataList
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/listbase.js